import l10n from '../../../shared/strings';
import { LISTING_STATUS } from '../constants/listingStatus';
import { getProductChannel } from './channelHelpers';
import { resolveChannelLabel, resolveChannelLabels } from './showPublishedToChannelToast';

export const DRAFT_TOAST_MODE = {
  CREATED: 'created',
  UPDATED: 'updated',
};

export const splitDraftToastChannelIds = ({
  product,
  productsState,
  channelIds = [],
}) => {
  const createdChannelIds = [];
  const updatedChannelIds = [];

  channelIds.forEach((channelId) => {
    const channel = getProductChannel(product, channelId, productsState);
    if (channel?.listingProduct?._id && channel.listingStatus === LISTING_STATUS.DRAFT) {
      updatedChannelIds.push(channelId);
      return;
    }
    createdChannelIds.push(channelId);
  });

  return { createdChannelIds, updatedChannelIds };
};

export const showDraftForChannelToast = ({
  Toast,
  channelIds = [],
  salesChannels = [],
  mode = DRAFT_TOAST_MODE.CREATED,
}) => {
  if (!channelIds.length) {
    return;
  }

  const isUpdated = mode === DRAFT_TOAST_MODE.UPDATED;

  if (channelIds.length === 1) {
    const channelLabel = resolveChannelLabel(channelIds[0], salesChannels);
    const message = isUpdated
      ? l10n.TOAST.DRAFT_FOR_CHANNEL_UPDATED(channelLabel)
      : l10n.TOAST.DRAFT_FOR_CHANNEL(channelLabel);
    Toast(message, { type: 'success' });
    return;
  }

  const channelLabels = resolveChannelLabels(channelIds, salesChannels);
  const message = isUpdated
    ? l10n.TOAST.DRAFT_FOR_CHANNELS_UPDATED(channelLabels)
    : l10n.TOAST.DRAFT_FOR_CHANNELS(channelLabels);
  Toast(message, { type: 'success' });
};

export const showSplitDraftToasts = ({
  Toast,
  createdChannelIds = [],
  updatedChannelIds = [],
  salesChannels = [],
}) => {
  showDraftForChannelToast({
    Toast,
    channelIds: createdChannelIds,
    salesChannels,
    mode: DRAFT_TOAST_MODE.CREATED,
  });
  showDraftForChannelToast({
    Toast,
    channelIds: updatedChannelIds,
    salesChannels,
    mode: DRAFT_TOAST_MODE.UPDATED,
  });
};
